module.exports = __webpack_public_path__ + "img/feishuGroup.c8e8f267.jpeg";